import $ from 'jquery';
import Hammer from 'hammerjs';

const CAROUSEL_DURATION = 5000;

var $window = $(window);

$.fn.isVisible2 = function () {
  var viewportTop = $window.scrollTop();
  var viewportBottom = viewportTop + $window.height();
  var compareTop = $(this).offset().top;
  return viewportBottom >= compareTop;
};

class PostContentCarousel {
  constructor(element) {
    this.$element = $(element);
    this.$items = this.$element.find('.post-content-carousel__carousel-item');
    this.$itemsCaptions = this.$element.find('.post-content-carousel__caption-item');
    this.$activeElement = this.$element.find('.post-content-carousel__carousel-item.active');
    this.intervalId = null;

    this.addListeners();

    window.requestAnimationFrame(this.checkVisible.bind(this));
  }

  checkVisible() {
    if (this.$element.isVisible2()) {
      this.startInterval();
    } else {
      window.requestAnimationFrame(this.checkVisible.bind(this));
    }
  }

  addListeners() {
    this.$element.find('.post-content-carousel__previous').click(() => {
      this.startInterval();
      this.previous();
    });

    this.$element.find('.post-content-carousel__next').click(() => {
      this.startInterval();
      this.next();
    });
  }

  startInterval() {
    clearInterval(this.intervalId);
    this.intervalId = setInterval(() => {
      this.next();
    }, CAROUSEL_DURATION);
  }

  previous() {
    if (this.$activeElement.is(':first-child')) {
      this.setActiveElement(this.$items.last());
    } else {
      this.setActiveElement(this.$activeElement.prev());
    }
  }

  next() {
    if (this.$activeElement.is(':last-child')) {
      this.setActiveElement(this.$items.first());
    } else {
      this.setActiveElement(this.$activeElement.next());
    }
  }

  setActiveElement($element) {
    this.$activeElement = $element;
    this.setClasses();
  }

  setClasses() {
    this.$items.removeClass('former-previous former-active former-next');
    this.$items.filter('.active').removeClass('active').addClass('former-active');
    this.$items.filter('.previous').removeClass('previous').addClass('former-previous');
    this.$items.filter('.next').removeClass('next').addClass('former-next');

    this.$activeElement.addClass('active');
    let $prev = this.$activeElement.is(':first-child') ? this.$items.last() : this.$activeElement.prev();
    let $next = this.$activeElement.is(':last-child') ? this.$items.first() : this.$activeElement.next();
    $prev.addClass('previous');
    $next.addClass('next');

    this.$itemsCaptions.removeClass('active');
    this.$itemsCaptions.eq(this.$activeElement.index()).addClass('active');
  }
}

$('.post-content-carousel').each(function (index, element) {
  new PostContentCarousel(element);
});
